const generalTitles =
  {
    TITLE_MANAGER: 'Gerentes',
    TITLE_TERRITORY: 'Territorios',
    TITLE_ZONES: 'Zonas',
    TITLE_BOSSES: 'Jefes',
    TITLE_BUDGET: 'Presupuestos',
    TITLE_4W: 'Tabla de segmentación 4W',
    SUB_TITLE_CARD: 'Cree, filter y edite',
    TERRITORY: 'Territorio',
    MANAGER: 'Gerente',
    BOSSES: 'Jefe',
    ADD: 'Añadir',
    NEW: 'Nuevo',
    TITLE_TABLE_TERRITORY: 'Territorios y zonas asignadas',
    TITLE_TABLE_MANAGERS: 'Gerentes y jefes asignados',
    TITLE_TABLE_BOSSES: 'Territorios y jefes asignados',
    TITLE_CARD_BUDGETS: 'Tabla de presupuestos',
    SEGMENT_WARNING: 'Segmento existente',
    MAP_TITLE: 'Distribución Geográfica',
    MAP_SUBTITLE: 'Seleccione y/o asigne zonas comerciales'
  }
export default generalTitles
